import { Card } from '@/components/cards/card'
import Resx from '@/components/Resx'
import React from 'react'
import { BackgroundJobMessagesButton } from '@/components/backgroundJobs/backgroundJobMessagesButton'
import { Button } from '@/components/button'

function StatusBasedCard ({ status,
  cardColor,
  icon,
  headerText,
  beforeStartText,
  backgroundJobMessages,
  finishedMessage,
  renderFinishedMessage,
  onRetryClick,
  hasError,
  dataCy,
  ...props }) {
  let generatedIcon = ''
  if (icon) generatedIcon = icon
  else {
    switch (status) {
      case 'notStarted': generatedIcon = 'bx-square'
        break
      case 'active': generatedIcon = 'bx-right-arrow'
        break
      case 'finished': generatedIcon = 'bx-check'
        break
    }
  }

  return <Card dataCy={dataCy} borderColor={cardColor} headerText={headerText} icon={generatedIcon}>
    { status === 'notStarted' && <Resx name={beforeStartText} /> }
    { status === 'active' && props.children }
    { status === 'finished' && finishedMessage && <React.Fragment>
      {backgroundJobMessages && <BackgroundJobMessagesButton backgroundJobMessages={backgroundJobMessages} />}
      <Resx name={finishedMessage} />
      {hasError && typeof onRetryClick === 'function' && <Button
        onClick={onRetryClick}
        icon='revision'
        confirmTitle='Common.Retry'
        confirmText='Common.AreYouSure'>
        <Resx name='Common.Retry' />
      </Button> }
    </React.Fragment> }
    { status === 'finished' && renderFinishedMessage && renderFinishedMessage() }
  </Card>
}

export { StatusBasedCard }



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/submit/statusBasedCard.js